module.exports = __webpack_public_path__ + "img/logo.262400ea.svg";